import request from '@/utils/request'

export function fetchUserReport(query) {
  return request({
    url: '/v1/user-reports',
    method: 'get',
    params: query
  })
}